// shakeTutorialAnimation.js
var ShakeTutorialAnimation = pc.createScript('shakeTutorialAnimation');

// initialize code called once per entity
ShakeTutorialAnimation.prototype.initialize = function() {

this.entity
    .tween(this.entity.getLocalEulerAngles())
    .rotate(new pc.Vec3(25, 0, 0), 0.4, pc.Linear)
    .loop(true)
    .yoyo(true)
    .start();
};


